<template>
  <div class="px-2">
    <b-card class="w-100 d-flex rounded-lg flex-column">
      <!-- Search and Filter Section -->
      <div class="row text-light pb-3 pt-2 mt-1">
        <div class="col-md-6 mb-2">
          <v-select
            v-model="filter.experiment_id"
            :options="experimentsLookups"
            :reduce="(val) => val.id"
            label="name"
            placeholder="Filter by Experiment"
            class="institution-select"
            :clearable="true"
          />
        </div>
        <div class="col-md-6 mb-2">
          <form
            class="search-form search-form-theme2 w-100"
            @submit.prevent
          >
            <img
              src="@/assets/images/skeleton/search.png"
              class="fas fa-search search-icon"
              alt="search"
            >
            <input
              v-model="filter.keyword"
              type="text"
              placeholder="Search in Users"
              name="Search"
              class="search-input"
            >
          </form>
        </div>
      </div>

      <center v-if="isLoading">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <b-row
        v-else
        class="py-2"
      >
        <center
          v-if="!isLoading && chatbotSessions.data.length === 0"
          class="w-100 text-center mr-3"
        >
          <h3>No Data to show</h3>
        </center>
        <b-table
          v-if="!isLoading && chatbotSessions.data.length > 0"
          striped
          hover
          :items="chatbotSessions.data"
          :fields="fields"
          tbody-tr-class="cursor-pointer"
          @row-clicked="onRowClicked"
        >
          <template #cell(user)="data">
            <b-link
              v-if="data.item.user && data.item.user.id"
              :to="{ name: 'pages_profile', params: { user_id: data.item.user.id } }"
              class="text-nowrap text-primary font-weight-bold"
              @click.native.stop
            >
              {{ data.value.fname + " " + data.value.lname }}
            </b-link>
            <span
              v-else
              class="text-nowrap"
            >
              {{ data.value ? (data.value.fname + " " + data.value.lname) : "N/A" }}
            </span>
          </template>

          <template #cell(experiment.name)="data">
            <b-link
              v-if="data.item.experiment && data.item.experiment.id"
              :to="{ name: 'experiment_details', params: { id: data.item.experiment.id } }"
              class="text-primary font-weight-bold"
              @click.native.stop
            >
              {{ data.item.experiment.name }}
            </b-link>
            <span v-else>{{ (data.item.experiment && data.item.experiment.name) || "N/A" }}</span>
          </template>
          <template #cell(consumed_tokens)="data">
            <!-- 1. Check if Gemini has non-zero tokens -->
            <div v-if="data.item.gemini_consumed_tokens && (data.item.gemini_consumed_tokens.totalTokenCount > 0 || data.item.gemini_consumed_tokens.promptTokenCount > 0 || data.item.gemini_consumed_tokens.candidatesTokenCount > 0)">
              {{ data.item.gemini_consumed_tokens.totalTokenCount || 0 }}
              <!-- <ul>
                <li>
                </li>
                <li>
                  Input: {{ data.item.gemini_consumed_tokens.promptTokenCount || 0 }}
                </li>
                <li>
                  Output: {{ data.item.gemini_consumed_tokens.candidatesTokenCount || 0 }}
                </li>
              </ul> -->
            </div>
            <!-- 2. Check if Azure has non-zero tokens -->
            <div v-else-if="data.item.azure_consumed_tokens && (data.item.azure_consumed_tokens.total_tokens > 0 || data.item.azure_consumed_tokens.prompt_tokens > 0 || data.item.azure_consumed_tokens.completion_tokens > 0)">
              {{ data.item.azure_consumed_tokens.total_tokens || 0 }}
              <!-- <ul>
                <li>
                </li>
                <li>
                  Input: {{ data.item.azure_consumed_tokens.prompt_tokens || 0 }}
                </li>
                <li>
                  Output: {{ data.item.azure_consumed_tokens.completion_tokens || 0 }}
                </li>
              </ul> -->
            </div>
            <!-- 3. Fallback: if Gemini is present (even if 0) -->
            <div v-else-if="data.item.gemini_consumed_tokens">
              {{ data.item.gemini_consumed_tokens.totalTokenCount || 0 }}
              <!-- <ul>
                <li>
                </li>
                <li>
                  Input: {{ data.item.gemini_consumed_tokens.promptTokenCount || 0 }}
                </li>
                <li>
                  Output: {{ data.item.gemini_consumed_tokens.candidatesTokenCount || 0 }}
                </li>
              </ul> -->
            </div>
            <!-- 4. Fallback: if Azure is present (even if 0) -->
            <div v-else-if="data.item.azure_consumed_tokens">
              {{ data.item.azure_consumed_tokens.total_tokens || 0 }}
              <!-- <ul>
                <li>
                </li>
                <li>
                  Input: {{ data.item.azure_consumed_tokens.prompt_tokens || 0 }}
                </li>
                <li>
                  Output: {{ data.item.azure_consumed_tokens.completion_tokens || 0 }}
                </li>
              </ul> -->
            </div>
          </template>
          <template #cell(Actions)="data">
            <div class="d-flex justify-content-start align-items-center">
              <b-link
                :tooltip="'none'"
                class="alert-link cutom-alert-link mr-1"
                :to="{ name: 'show_chatbot', params: { id: data.item.id } }"
              >
                <feather-icon
                  v-b-tooltip.hover.top="'Show'"
                  :tooltip="'none'"
                  icon="EyeIcon"
                  size="18"
                />
              </b-link>
              <!-- <b-link
                :tooltip="'none'"
                class="alert-link cutom-alert-link mr-1"
                :to="{ name: 'edit_institution', params: { id: data.item.id} }"
              >
                <feather-icon
                  :tooltip="'none'"
                  icon="EditIcon"
                  size="18"
                  v-b-tooltip.hover.top="'Edit'"
                />
              </b-link>
              <b-link
                :tooltip="'none'"
                class="alert-link cutom-alert-link text-danger"
                @click="deleteChatbotSession(data.item.id)"
              >
                <feather-icon
                  :tooltip="'none'"
                  icon="Trash2Icon"
                  size="18"
                  v-b-tooltip.hover.top="'Delete'"
                />
              </b-link> -->
            </div>
          </template>
        </b-table>
      </b-row>

      <!-- Pagination & Per Page -->
      <b-row class="mt-2 w-100 align-items-center" v-if="chatbotSessions && chatbotSessions.meta">
        <b-col md="4" class="text-light d-flex align-items-center" style="font-size: 0.95rem;">
          <span v-if="chatbotSessions.meta.total > 0" class="d-flex align-items-center" style="margin-left: 2px;">
            Showing 
            <b-form-select
              v-model="filter.per_page"
              :options="[10, 25, 50, 100]"
              class="custom-per-page mx-1"
              @change="onPageChange(1)"
            />
          </span>
        </b-col>
        <b-col md="4" class="d-flex justify-content-center">
          <b-pagination
            v-model="chatbotSessions.meta.current_page"
            :total-rows="chatbotSessions.meta.total"
            :per-page="chatbotSessions.meta.per_page"
            @change="onPageChange"
            class="mb-0"
          />
        </b-col>
        <b-col md="4"></b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BSpinner,
  BContainer,
  BRow,
  BCol,
  BButton,
  BCard,
  BTable,
  VBTooltip,
  BLink,
  BPagination,
  BFormSelect,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

export default {
  name: 'ChatbotSessions',
  components: {
    BLink,
    VBTooltip,
    BSpinner,
    BContainer,
    BTable,
    BRow,
    BCol,
    BButton,
    BCard,
    BPagination,
    vSelect,
    BFormSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters({
      chatbotSessions: 'chatbot/items',
      experimentsLookups: 'experiments/experimentsLookups',
    }),
    fields() {
      const baseFields = [
        { key: 'experiment.name', label: 'experiment', sortable: true },
        { key: 'user', label: 'user', sortable: true },
        { key: 'created_at', label: 'created at', sortable: true },
      ]
      if (this.hasPermission('Token Usage User')) {
        baseFields.push({ key: 'consumed_tokens', label: 'Consumed Tokens', sortable: false })
      }
      baseFields.push(
        { key: 'ai_provider', label: 'AI Provider', sortable: false },
        'Actions',
      )
      return baseFields
    },
  },
  data() {
    return {

      isLoading: false,
      filter: {
        experiment_id: null,
        keyword: null,
        per_page: 10,
      },
    }
  },
  watch: {
    'filter.keyword': function (newVal) {
      // Debounce search
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.refresh()
      }, 500)
    },
    'filter.experiment_id': function (newVal) {
      this.refresh()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    onRowClicked(item) {
      this.$router.push({ name: 'show_chatbot', params: { id: item.id } })
    },
    init() {
      this.$store.dispatch('experiments/experimentsLookups')
      this.$store
        .dispatch('chatbot/list', this.filter)
        .then(response => {
          this.isLoading = false
        })
        .catch(e => {
          console.log(e.response)
          this.$swal({
            icon: 'error',
            title: `<h4>Error fetching institution details: ${e.message}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        })
    },
    refresh() {
      this.$store.dispatch('chatbot/list', {
        page: this.chatbotSessions.meta.current_page,
        ...this.filter,
      })
    },
    onPageChange(page) {
      this.$store.dispatch('chatbot/list', { page, ...this.filter })
    },

    deleteInstitution(id) {
      this.$swal({
        title: '<h4>Are you sure you want to delete this chatbot session?</h4>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#7367f0',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
      }).then(result => {
        if (result.isConfirmed) {
          this.isLoading = true
          this.$store
            .dispatch('chatbot/remove', id)
            .then(response => {
              this.isLoading = false
              this.refresh()
            })
            .catch(e => {
              this.$swal({
                icon: 'error',
                title: `<h4>Error removing institution: ${e.message}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
            })
        } else {
          this.isLoading = false
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.search-form {
  position: relative;
  width: 100%;
  background-color: transparent;
  border: 1px solid #ffffff75;
  border-left: none;
  border-right: none;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
}

.search-form-theme2 {
  position: relative;
  width: 100%;
  border-left: none;
  border-right: none;
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
  background-color: #00000040;
  border: 1px solid #ffffff75;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgb(0 0 0 / 65%);
  border-top: unset;
}

.search-form:focus-within {
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);
}

.search-form input[type="text"],
.search-form input[type="search"] {
  width: 100%;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 16px;
  outline: none;
}

.search-form input::placeholder {
  color: #ffffffa8;
}

.search-form .search-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #bbb;
  font-size: 16px;
  cursor: pointer;
}

.institution-select {
  ::v-deep .vs__dropdown-toggle {
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 5px;
  }

  ::v-deep .vs__search,
  ::v-deep .vs__search:focus {
    color: #fff;
  }

  ::v-deep .vs__selected {
    color: #fff;
  }

  ::v-deep .vs__dropdown-menu {
    background: #2c2c2c;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  ::v-deep .vs__dropdown-option {
    color: #fff;

    &:hover {
      background: rgba(115, 103, 240, 0.3);
    }
  }
}

.cursor-pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

[dir] .dark-layout input.form-control,
[dir] .dark-layout .custom-file-label,
[dir] .dark-layout textarea.form-control {
  height: 45px;
  box-shadow: black beige indigo;
  border-radius: 8px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  background: linear-gradient(
    90deg,
    rgba(158, 63, 217, 0.2) 0%,
    rgba(37, 78, 158, 0.2) 49%,
    rgba(70, 124, 227, 0.2) 100%
  );
  border: 2px solid #ffffff3c;
  border-left: none;
  border-right: none;
  border-top: none;
}
[dir] .dark-layout input.form-control:not(:focus),
[dir] .dark-layout .custom-file-label:not(:focus),
[dir] .dark-layout textarea.form-control:not(:focus) {
  border-color: #ffffff3c;
}

.field-icon {
  position: absolute;
  top: 10px;
  left: 30px;
  color: #ffffffcc !important;
  font-weight: 500;
}
</style>
